import React from 'react';
import Logo from './Logo';
import TopNav from '@hig/top-nav';
import '@hig/top-nav/';

const Header = () => {
  return (
    <div className="pda-header">
      <TopNav
        key="pda-top-nav"
        logo={<Logo />}
      />
    </div>

  )
}

export default Header;
